<mat-card class="cardWithShadow">
    <mat-card-content class="p-24">

        <div style="text-align: center;" *ngIf="result.results.length == 0">
            <h3>Sin Facturas</h3>
        </div>

        <div class="table-responsive" [ngClass]="{ 'oculto': result.results.length == 0 }">
            <table mat-table
            matSort
            (matSortChange)="sortOrderChange($event)"
            [dataSource]="dataSource" class="w-100">
                <ng-container matColumnDef="folio">
                    <th class="th-header" mat-sort-header mat-header-cell *matHeaderCellDef>
                        Folio
                    </th>
                    <td class="mat-body-1" mat-cell *matCellDef="let element">
                        <h6>{{ element.folio }} </h6>
                    </td>
                </ng-container>

                <ng-container matColumnDef="clientRut">
                    <th class="th-header" mat-sort-header mat-header-cell *matHeaderCellDef>
                        Rut
                    </th>
                    <td class="mat-body-1" mat-cell *matCellDef="let element">
                        <h6>{{ element.clientRut }}</h6>
                    </td>
                </ng-container>

                <ng-container matColumnDef="clientName">
                    <th class="th-header" mat-sort-header mat-header-cell *matHeaderCellDef>
                        Nombre
                    </th>
                    <td class="mat-body-1" mat-cell *matCellDef="let element">
                        <h6>{{ element.clientName}}</h6>
                    </td>
                </ng-container>

                <ng-container matColumnDef="fechaDocto">
                    <th class="th-header" mat-header-cell mat-sort-header *matHeaderCellDef>
                        Fecha Documento
                    </th>
                    <td class="mat-body-1" mat-cell *matCellDef="let element">
                        <h6>{{ element.fechaDocto | date: 'dd-MM-yyyy'}}</h6>
                    </td>
                </ng-container>

                <ng-container matColumnDef="totalAmount">
                    <th class="th-header" mat-sort-header mat-header-cell *matHeaderCellDef>
                        Monto Total
                    </th>
                    <td class="mat-body-1" mat-cell *matCellDef="let element">
                        <h6>{{ element.totalAmount | currency : "CLP" : "symbol" }}</h6>
                    </td>
                </ng-container>

                <ng-container matColumnDef="hasBuyOrder">
                    <th mat-header-cell *matHeaderCellDef class="th-header">Orden de compra</th>
                    <td class="mat-body-1" mat-cell *matCellDef="let element">
                        <i-tabler class="icon-20"
                        [name]="element.hasBuyOrder ? 'circle-check-filled' : 'circle-x-filled'"
                        [style.color]="element.hasBuyOrder ? 'mediumspringgreen' : 'red'">
                        </i-tabler>
                    </td>
                </ng-container>

                <ng-container matColumnDef="isCedible">
                    <th mat-header-cell *matHeaderCellDef class="th-header">Cedible</th>
                    <td class="mat-body-1" mat-cell *matCellDef="let element">
                        <h6> {{element.isCedible }} </h6>
                    </td>
                </ng-container>

                <ng-container matColumnDef="numberInvoice">
                    <th mat-header-cell *matHeaderCellDef class="th-header">
                        N° Factura con proveedor
                    </th>
                    <td class="mat-body-1" mat-cell *matCellDef="let element">
                        <h6>{{element.numberInvoice}}</h6>
                    </td>
                </ng-container>

                <ng-container matColumnDef="numberInvoiceInFactoring">
                    <th mat-header-cell *matHeaderCellDef class="th-header">
                        N° Facturas relacionadas con Factoring
                    </th>
                    <td class="mat-body-1" mat-cell *matCellDef="let element">
                        <h6>{{element.numberInvoiceInFactoring}}</h6>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayCols"></tr>
                <tr mat-row class="cursor-table"
                [cdkContextMenuTriggerFor]="menu"
                *matRowDef="let row; columns: displayCols">
                <ng-template #menu>
                    <div cdkMenu class="context_menu mat-elevation-z8">
                      
                      <button class="context-menu-item"
                      cdkMenuItem mat-raised-button
                      (click)="viewDebtorRelation(row.clientRut)">
                        Ver relación con proveedor
                      </button>
                    </div>
                  </ng-template>
                    
                </tr>
            </table>
            <mat-paginator (page)="changePaginationTable($event)" [pageSizeOptions]="[5, 10, 20, 100]"></mat-paginator>
        </div>
    </mat-card-content>
</mat-card>
